/**
 * app.ts - Main Application Entry Point (REFACTORED)
 *
 * This file is now a lightweight entry point.
 * All functionality has been modularized into /src-frontend/modules/
 *
 * Module loading order is managed by TypeScript compilation and bundling:
 * 1. Type definitions (types/)
 * 2. Utilities (i18n, security, constants, formatting, state)
 * 3. API clients (tournament-api, player-api, match-api)
 * 4. Tournament modules (card, list, crud, ui, players, matches, pairings, standings, sharing, schedule)
 * 5. Auth modules
 * 6. Init (app-init)
 *
 * Application is initialized by app-init.ts when DOM is ready
 */

// Import all modules in the correct order to ensure they're bundled

// 1. Core utilities
import './modules/i18n/i18n';
import './modules/utils/security';
import './modules/utils/constants';
import './modules/utils/i18n-helper';
import './modules/utils/score-calculator';
import './modules/utils/formatting';
import './modules/utils/state';
import './modules/utils/logo-handler';

// 2. API clients
import './modules/api/tournament-api';
import './modules/api/player-api';
import './modules/api/match-api';
import './modules/api/profile-api';
import './modules/api/registration-api';
import './modules/api/public-tournaments-api';

// WebSocket client for real-time updates
import './modules/websocket/websocket-client';

// 3. Auth modules
import './modules/auth/auth-api';
import './modules/auth/auth-state';
import './modules/auth/auth-ui';
import './modules/auth/auth-modals';
import './modules/auth/auth-handlers';
import './modules/auth/auth-init';

// Billing modules
import './modules/billing/pricing';
import './modules/billing/billing';

// Demo module
import './modules/demo/demo';

// 4. Tournament modules
import './modules/tournament/card';
import './modules/tournament/ui';
import './modules/tournament/inline-edit';
import './modules/tournament/publication';

// Players submodules
import './modules/tournament/players/player-search-parsers';
import './modules/tournament/players/player-search';
import './modules/tournament/players/player-suggestions';
import './modules/tournament/players/player-crud';
import './modules/tournament/players/field-autocomplete';
import './modules/tournament/players/bye-management';
import './modules/tournament/players/prohibited-pairings';

// Matches submodules
import './modules/tournament/matches/round-selector';
import './modules/tournament/matches/match-renderer';
import './modules/tournament/matches/result-handler';
import './modules/tournament/matches/keyboard-shortcuts';
import './modules/tournament/matches/manual-pairing';
import './modules/tournament/pairings';

// Standings submodules
import './modules/tournament/standings/knockout-bracket';
import './modules/tournament/standings/standings-renderer';
import './modules/tournament/standings/print-standings';
import './modules/tournament/standings/standings-loader';

// Tournament management
import './modules/tournament/sharing';
import './modules/tournament/schedule';
import './modules/tournament/publication';
import './modules/tournament/categories';
import './modules/tournament/registration-modal';
import './modules/tournament/registrations-ui';
import './modules/tournament/entry-fees-ui';
import './modules/tournament/stripe-connect-ui';
import './modules/tournament/crud';
import './modules/tournament/list';

// Profile and Directory modules
import './modules/profile/profile-ui';
import './modules/directory/tournaments-directory';

// 5. Initialization (must be last)
import './modules/init/app-init';

console.log('♟️ nextround - Chess Tournament Manager');
console.log('📦 TypeScript modular architecture loaded');
